
const DOMAIN_NAME = 'https://unatam.com';
const DOMAIN_NAME_API = 'https://api.unatam.com';



/*const DOMAIN_NAME_API = 'http://localhost:8000';
const DOMAIN_NAME = 'http://localhost:3000';*/
const DOMAIN_NAME_IMG = 'https://d20pa0791atmy3.cloudfront.net/'
export { DOMAIN_NAME, DOMAIN_NAME_API,  DOMAIN_NAME_IMG};
